import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Question } from './icons'
import styles from './Hint.scss'
import onClickOutside from 'react-onclickoutside'

class _ShowHint extends Component {
  constructor(props) {
    super(props)
    this.state = {
      left: this.props.width ? -(this.props.width / 2 - 10) : ''
    }
  }

  componentDidMount = () => {
    const { left } = this.props
    const pointLeft = this.pointRel.offsetLeft + this.pointAbs.offsetLeft
    const pointRight = this.pointRel.offsetLeft + this.pointAbs.offsetLeft + this.pointAbs.clientWidth

    if (left) {
      return this.setState({ left })
    }

    if (pointRight > window.innerWidth) {
      this.setState({
        left: this.pointAbs.offsetLeft - (pointRight - window.innerWidth) - 5
      })
    }

    if (pointLeft < 0) {
      this.setState({
        left: -this.pointRel.offsetLeft + 5
      })
    }
  }

  handleClickOutside = () => {
    this.props.onClick()
  }

  render() {
    const text = this.props.text
    const width = this.props.width ? this.props.width + 'px' : ''

    return (
      <div className={styles.hintBaloon} ref={pointRel => (this.pointRel = pointRel)}>
        <div className={styles.hintShape} />
        <div
          className={styles.hintMessage}
          style={{ width: width, left: this.state.left }}
          ref={pointAbs => (this.pointAbs = pointAbs)}>
          {text}
        </div>
      </div>
    )
  }
}

export const ShowHint = onClickOutside(_ShowHint)

class Hint extends Component {
  static propTypes = {
    width: PropTypes.number,
    text: PropTypes.node,
    compoennt: PropTypes.element,
    size: PropTypes.number
  }

  constructor(props) {
    super(props)
    this.state = {
      isHintOpen: false
    }
  }

  handleClick = () => {
    const { isHintOpen } = this.state
    this.setState({
      isHintOpen: !isHintOpen
    })
  }

  hideInfo = () => {
    this.setState({
      isHintOpen: false
    })
  }

  render() {
    const { text, width, component: Icon = Question, size, messageLeft: left, baseLine } = this.props
    const { isHintOpen } = this.state
    return (
      <div className={baseLine ? `${styles.hintWrap} ${styles.hintWrapBaseLine}` : styles.hintWrap}>
        <Icon
          size={size || 16}
          onClick={this.handleClick}
          className={isHintOpen ? styles.hintIconOpened : styles.hintIcon}
        />
        {isHintOpen && <ShowHint onClick={this.hideInfo} text={text} width={width} left={left} />}
      </div>
    )
  }
}

export default Hint
